import React from 'react';
import { connect } from 'react-redux';
import { Redirect,Link } from 'react-router-dom';
import * as actions from '../../redux/tasks/actions';

const selectTaskCategory=(props,taskCategory)=>{
    props.selectTaskCategory(taskCategory);
}

const TaskCategory=(props)=>{
    const { taskCategory } = props;
    const redirectTo=`/projectTasks/${taskCategory.id}`
    return (
        <div className="col-sm-4 taskCategoryLink" >
            <Link to={redirectTo} >
                <div className="card taskCategoryContainer">
                    <div className="card-body">
                        <h4 className="card-title">{taskCategory.title}</h4>
                        <p className="card-text">{taskCategory.description}</p>
                    </div>
                </div>
            </Link>
        </div>
    )
}

class TaskCategories extends React.Component {
    componentWillMount(){
        this.props.getTaskCategories(this.props.auth.jwtToken);
    }

    render(){
        const { taskDist } = this.props;
        
        return (
            <div className='container'>
                <div className='row'>
                    <br />
                </div>
                <div className='row'>
                    <br />
                </div>
                <div className='row'>
                    {taskDist.taskCategories.map((taskCategory)=>(
                        <TaskCategory key={taskCategory.id} taskCategory={taskCategory}  {...this.props} />
                    ))}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
       auth: state.auth,
       taskDist: state.taskDist
    }
}
  
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getTaskCategories: (jwt) => {
            dispatch(actions.getTaskCategories(jwt))
        },
        selectTaskCategory: (taskCategory) => {
            dispatch(actions.selectTaskCategory(taskCategory))
        }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(TaskCategories);


// WEBPACK FOOTER //
// ./src/views/TaskCategories/TaskCategories.js